<template>
    <v-container class="safari-warning-container" fluid>
        <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
                <v-alert border="left" prominent class="safari-warning-alert">
                    <div class="warning-text">
                        Oh no! ☹ Likely, your browser settings are preventing your login. Please follow this link to resolve the issue:
                    </div>
                    <a class="link-text" @click="learnMore()">Click here</a>
                </v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "SafariWarning",
    methods: {
        learnMore(){
            window.open('/BrowserGuide.pdf', '_blank')
        }
    }
};
</script>

<style lang="css" scoped>
.safari-warning-container {
    margin-bottom: 20px; /* Adds spacing below the warning */
}

.safari-warning-alert {
    padding: 10px 15px; /* Reduces padding for a more compact look */
    font-size: 14px; /* Adjusts font size for better vertical alignment */
    border-radius: 8px; /* Matches the login card's rounded corners */
    background-color: #FF5722;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Adds a subtle shadow for better visibility */
}

.warning-text {
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    text-align: center; /* Centers the text for a clean vertical layout */
}

.link-text {
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    text-decoration: underline;
    cursor: pointer; /* Changes the cursor to a pointer on hover */
}
</style>